import React from "react";

import styles from "./styles.css";

export const PageHeaderItem = ({ text, children }) =>
	(
		<div className={styles.headerItemWrapper}>
			<div className={styles.headerItemText}>{text}</div>
			<div className={styles.headerItemChildren}>{children}</div>
		</div>
	);


